import "../../assets/css/themify-icons.css"

export const FormIcon = ({_key,name,value,input,change}:any) => {
    return(
        <div className="mb-3">
            <label htmlFor={`ّiconInput${_key}`} className="form-label">{name}</label>
            <div className="input-group flex-nowrap" id={`ّiconInput${_key}`}>
                <span className="input-group-text" id={`iconWrappInput${_key}`}><i className={value}></i></span>
                <input type="text" className="form-control" onChange={change} defaultValue={value} name={input} placeholder={name} id={`iconInput${_key}`} aria-label={name} aria-describedby={`iconWrappInput${_key}`}/>
            </div>
            <div className="form-text text-end" id={`iconWrappInput${_key}`}>
               <a className="link-info link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover" href="https://fontawesome.com/v5/search" target="_blank" rel="noreferrer">جستجوی آیکون</a>
            </div>
        </div>
    )
}